// src/components/InputField.js
import React, { useContext } from 'react';
import styled from 'styled-components';
import ThemeContext from '../context/ThemeContext';

// Styled input container
const StyledInput = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid ${({ theme }) => theme.mainText};
  border-radius: 4px;
  background: ${({ theme }) => theme.mainField};
  color: ${({ theme }) => theme.mainText};
  box-sizing: border-box;
  transition: box-shadow 0.1s ease, border-color 0.1s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.mainBody};
    box-shadow: 0 0 8px 0 ${({ theme }) => theme.mainField};
  }

  &:disabled {
    background: ${({ theme }) => theme.mainBody};
    color: ${({ theme }) => theme.mainAccent};
  }

  &:hover:not(:disabled) {
    box-shadow: 0 0 5px 0 ${({ theme }) => theme.mainOff};
  }
`;

// Styled Textarea container
const StyledTextarea = styled.textarea`
  width: 100%;
  padding: 10px;
  height: 100px;
  border: 1px solid ${({ theme }) => theme.mainBody};
  border-radius: 4px;
  background: ${({ theme }) => theme.mainField};
  color: ${({ theme }) => theme.mainText};
  margin-bottom: 10px;
  box-sizing: border-box;
  transition: box-shadow 0.1s ease, border-color 0.1s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.mainText};
    box-shadow: 0 0 8px 0 ${({ theme }) => theme.mainBody};
  }

  &:disabled {
    background: ${({ theme }) => theme.mainBody};
    color: ${({ theme }) => theme.mainAccent};
  }

  &:hover:not(:disabled) {
    box-shadow: 0 0 5px 0 ${({ theme }) => theme.mainOff}; 
  }
`;

const InputField = ({ type = 'text', value, onChange, disabled, isTextarea = false, placeholder }) => {
  const { theme } = useContext(ThemeContext);

  return isTextarea ? (
    <StyledTextarea
      theme={theme}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
    />
  ) : (
    <StyledInput
      type={type}
      theme={theme}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
    />
  );
};

export default InputField;
